// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React, { useState } from "react";
import PropTypes from "prop-types";

import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  formHelperTextClasses,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const preventDefault = (event) => event.preventDefault();

const StyledFormHelperText = styled(FormHelperText)({
  [`&.${formHelperTextClasses.root}`]: {
    marginLeft: "2px",
  },
});

function PasswordInput({ autoFocus, error, helperText, onChange, value }) {
  const [showPassword, setShowPassword] = useState(false);
  const inputLabel = "Senha";

  const handleClickShowPassword = () => setShowPassword(!showPassword);

  return (
    <FormControl fullWidth variant="outlined" error={error}>
      <InputLabel htmlFor="password">{inputLabel}</InputLabel>
      <OutlinedInput
        autoFocus={autoFocus}
        id="password"
        type={showPassword ? "text" : "password"}
        value={value}
        onChange={onChange}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="exibir ou esconder senha"
              onClick={handleClickShowPassword}
              onMouseDown={preventDefault}
              edge="end"
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
        label={inputLabel}
      />
      <StyledFormHelperText>{helperText}</StyledFormHelperText>
    </FormControl>
  );
}

PasswordInput.defaultProps = {
  autoFocus: false,
  error: false,
};

PasswordInput.propTypes = {
  autoFocus: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default PasswordInput;
